import { ITokenizedCard } from 'modules/customer/domain/entities';

export interface IVectisTokenizedCard {
  id: number;
  numerosFinaisCartao: string;
  vencimento: string;
  bandeira: string;
  vencido: boolean;
  principal: boolean;
}

export class TokenizedCard implements ITokenizedCard {
  public id: ITokenizedCard['id'];
  public number: ITokenizedCard['number'];
  public flag: ITokenizedCard['flag'];
  public isMain: ITokenizedCard['isMain'];

  constructor({
    id,
    numerosFinaisCartao,
    bandeira,
    principal,
  }: IVectisTokenizedCard) {
    this.id = id;
    this.number = numerosFinaisCartao;
    this.flag = bandeira;
    this.isMain = principal;
  }
}
